<template>
	<div class="quad__block__child slider">
		<h4 v-html="title"></h4>

		<!-- Slider main container -->
		<div class="swiper-container">
			<!-- Additional required wrapper -->
			<div class="swiper-wrapper">
				<div
					class="swiper-slide"
					v-for="(slide, index) in JSON.parse(slides)"
					:key="index"
				>
					<!-- Testimonial Elements -->
					<p v-if="slide.testimonial" class="quote">"</p>
					<p
						class="testimonial"
						v-if="slide.testimonial"
						v-html="slide.testimonial"
					></p>
					<p
						class="testifier"
						v-if="slide.testifier"
						v-html="slide.testifier"
					></p>
					<p class="position" v-if="slide.position" v-html="slide.position"></p>

					<!-- Services Elements -->
					<h2 class="services" v-if="slide.title" v-html="slide.title"></h2>
					<p class="text" v-if="slide.text" v-html="slide.text"></p>
					<a class="link" v-if="slide.link" :href="slide.link"
						>Learn More &rarr;</a
					>
				</div>
			</div>

			<div class="swiper-pag-nag">
				<div class="swiper-pagination"></div>

				<div class="swiper-nav">
					<div class="swiper-button-prev-testimonial">
						<svg fill="none" viewBox="0 0 58 58">
							<defs />
							<g clip-path="url(#clip0)">
								<path
									fill="#0A110F"
									d="M29 58c5.7357 0 11.3425-1.7008 16.1115-4.8874 4.7691-3.1865 8.4861-7.7157 10.681-13.0148 2.1949-5.299 2.7692-11.13 1.6503-16.7554-1.119-5.6255-3.881-10.7928-7.9367-14.84848-4.0557-4.05573-9.223-6.81771-14.8485-7.93668C29.0322-.561731 23.2012.0125651 17.9022 2.20751 12.6031 4.40245 8.07394 8.11945 4.88738 12.8885 1.70082 17.6575 0 23.2644 0 29c0 7.6913 3.05535 15.0676 8.4939 20.5061C13.9325 54.9447 21.3087 58 29 58"
								/>
								<path
									fill="#BFC0C0"
									d="M27.6799 36c-.1103.0022-.2173-.0371-.3-.11l-6.19-6.29c-.0896-.0775-.1624-.1725-.214-.2791-.0516-.1066-.0808-.2226-.086-.3409.0063-.1181.0361-.2338.0876-.3402.0515-.1065.1237-.2016.2124-.2798l6.19-6.36c.0374-.0439.0832-.0797.1348-.1055.0515-.0257.1077-.0409.1652-.0445.1028.0143.1961.0681.26.15l1.85 1.88c.0818.0639.1356.1571.15.26-.0129.1061-.0667.203-.15.27l-2.85 2.82h9.58c.2 0 .3.09.3.29v2.76c.0048.0405.0004.0817-.013.1203-.0134.0385-.0353.0736-.0642.1025-.0289.0289-.0639.0508-.1025.0642-.0386.0134-.0797.0178-.1203.013h-9.58l2.85 2.82c.0413.0309.076.0698.1018.1145.0257.0447.0422.0942.0482.1455-.0129.1061-.0667.203-.15.27l-1.85 1.88c-.0268.0488-.064.091-.1089.1239-.0449.0328-.0965.0554-.1511.0661z"
								/>
							</g>
							<defs>
								<clipPath id="clip0">
									<path fill="#fff" d="M0 0h58v58H0z" />
								</clipPath>
							</defs>
						</svg>
					</div>
					<div class="swiper-button-next-testimonial">
						<svg fill="none" viewBox="0 0 58 58">
							<defs />
							<g clip-path="url(#clip0)">
								<path
									fill="#0A110F"
									d="M29 0c-5.7356 0-11.3425 1.70082-16.1115 4.88738C8.11945 8.07394 4.40245 12.6031 2.20751 17.9022.0125651 23.2012-.561731 29.0322.55724 34.6576c1.11897 5.6255 3.88095 10.7928 7.93668 14.8485 4.05568 4.0557 9.22298 6.8177 14.84848 7.9367 5.6254 1.1189 11.4564.5446 16.7554-1.6503 5.2991-2.1949 9.8283-5.9119 13.0148-10.681C56.2992 40.3425 58 34.7357 58 29c0-7.6913-3.0553-15.0675-8.4939-20.5061C44.0676 3.05535 36.6913 0 29 0"
								/>
								<path
									fill="#BFC0C0"
									d="M30.32 22c.1102-.0023.2173.037.3.11l6.19 6.29c.0896.0774.1624.1724.214.279.0515.1066.0808.2226.086.341-.0063.1181-.0361.2337-.0876.3402-.0515.1064-.1237.2015-.2124.2798L30.62 36c-.0374.0438-.0832.0797-.1348.1054-.0515.0258-.1077.0409-.1652.0446-.1029-.0144-.1961-.0682-.26-.15l-1.85-1.88c-.0819-.0639-.1357-.1572-.15-.26.0129-.1061.0667-.203.15-.27l2.85-2.82h-9.58c-.2 0-.3-.09-.3-.29v-2.8c-.0048-.0406-.0004-.0817.013-.1203.0133-.0386.0353-.0737.0642-.1025.0289-.0289.0639-.0509.1025-.0642.0386-.0134.0797-.0179.1203-.013h9.58l-2.85-2.82c-.0414-.0309-.076-.0699-.1018-.1146-.0258-.0447-.0422-.0942-.0482-.1454.0129-.1061.0667-.203.15-.27l1.85-1.88c.0309-.0414.0699-.076.1146-.1018.0447-.0258.0941-.0422.1454-.0482z"
								/>
							</g>
							<defs>
								<clipPath id="clip0">
									<path fill="#fff" d="M0 0h58v58H0z" />
								</clipPath>
							</defs>
						</svg>
					</div>
				</div>
			</div>

			<!-- If we need scrollbar -->
			<!-- <div class="swiper-scrollbar"></div> -->
		</div>
	</div>
</template>

<script>
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/swiper-bundle.css';
Swiper.use([Navigation, Pagination, Autoplay]);

export default {
	data() {
		return {
			smallSlider: null,
		};
	},

	props: {
		slides: {},
		title: {},
	},

	computed: {},

	watch: {},

	methods: {
		initSlider() {
			this.smallSlider = new Swiper('.swiper-container', {
				// Optional parameters
				direction: 'horizontal',
				loop: true,
				autoHeight: true,
				autoplay: false,
				observer: true,
				observeParents: true,
				// If we need pagination
				pagination: {
					el: '.swiper-pagination',
					type: 'fraction',
					renderProgressbar: function (progressbarFillClass) {
						return '<span class="' + progressbarFillClass + '"></span>';
					},
					renderFraction: function (currentClass, totalClass) {
						return (
							'<span class="' +
							currentClass +
							'"></span>' +
							'<span style="width: 50px; height: 1px; background: white; display: inline-block; margin: 5px;"></span>' +
							'<span class="' +
							totalClass +
							'"></span>'
						);
					},
				},

				// Navigation arrows
				navigation: {
					nextEl: '.swiper-button-next-testimonial',
					prevEl: '.swiper-button-prev-testimonial',
				},
			});
		},
	},

	components: {},

	created() {},
	mounted() {
		// eslint-disable-next-line no-unused-vars
		this.initSlider();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

/* write SCSS here */

.slider {
	background-color: #212121;
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	justify-content: flex-start;
	align-items: flex-start;
	padding: 100px;
	width: calc(100% - 200px);

	@media (max-width: 1500px) {
		padding: 50px;
		width: calc(100% - 100px);
	}

	@media (max-width: 900px) {
		padding: 25px;
		width: calc(100% - 50px);
	}
}

.swiper-container {
	width: 100%;
	// height: 250px;
	padding-bottom: 50px;

	.swiper-wrapper {
		.swiper-slide {
			width: 100% !important;

			.testimonial {
				color: white;
				font-weight: bold;
				line-height: 1.75rem;
				margin-left: 1px;
			}

			.testifier {
				color: white;
				font-weight: bold;
				margin-bottom: 0;
				margin-left: 1px;
			}

			.position {
				color: #2e4a53;
				font-weight: bold;
				margin-top: 0;
				margin-left: 1px;
			}

			.quote {
				font-family: 'Aveny-T PRO', Arial, Helvetica, sans-serif;
				color: #2e4a53;
				margin-bottom: 0;
				margin-left: 1px;
			}

			.services {
				color: white;
				font-weight: bold;
				line-height: 1.75rem;
				word-break: break-all;
				margin-left: 1px;
			}

			.text {
				color: white;
				font-weight: bold;
				line-height: 1.75rem;
				margin-left: 1px;
			}

			.link {
				color: $edc-red;
				font-weight: bold;
				text-decoration: none;
				margin-left: 1px;
			}
		}
	}
}

.swiper-pagination {
	color: white;
	width: 50%;
	left: 0;
	text-align: left;

	.fraction__dash {
		width: 50px;
		height: 1px;
		background: white;
		display: inline-block;
		margin: 5px;
	}
}

.swiper-pag-nag {
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	align-items: center;
	height: 40px;
	position: relative;
	width: 100%;
	bottom: 0;
	margin-top: 0;

	.swiper-nav {
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		z-index: 10;
		position: absolute;
		width: 50%;
		right: 0;

		.swiper-button-prev-testimonial,
		.swiper-button-next-testimonial {
			display: flex;
			margin-left: 10px;

			&:hover {
				cursor: pointer;

				svg {
					path {
						&:first-of-type {
							fill: $edc-red;
						}

						&:last-of-type {
							fill: white;
						}
					}
				}
			}

			svg {
				height: 40px;

				path {
					transition: 0.2s fill ease;
				}
			}
		}
	}
}
</style>





// WEBPACK FOOTER //
// resources/assets/scripts/vue/SmallSlider.vue